var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgTodo(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 23 15' }, props),
        React.createElement("path", { d: 'M21.469.47a.75.75 0 011.135.975l-.073.085L9.974 14.12a2.75 2.75 0 01-3.753.084l-.136-.13L.463 8.316a.75.75 0 01.99-1.121l.084.073 5.621 5.758c.45.46 1.17.5 1.665.11l.115-.1L21.469.47z' })));
}
export default SvgTodo;
//# sourceMappingURL=Todo.js.map